module.exports = __webpack_public_path__ + "static/media/america-atlas.8cc1b496.jpg";